export const ONBOARDING_CLAUDE_CODE_LOGO_SRC = "/onboarding/claude-code-logo.png"
export const ONBOARDING_OPENCLAW_LOGO_SRC = "/onboarding/openclaw-logo.png"
